export default __webpack_public_path__ + "static/media/AppliedStudents.b96f05a3.png";